import React from "react";
import { Provider } from "react-redux";
import { Store } from "redux";
import { BrowserRouter as Router } from "react-router-dom";
import {
  AuthProvider,
  AnalyticsProvider,
  ErrorTrackingProvider,
  Authenticator,
} from "component-library";
import { IApplicationState } from "app/store";
import config from "config/global";
import ErrorBoundary from "app-shell/ErrorBoundary/ErrorBoundary";
import { GoogleTagManager } from "app-shell/GoogleTagManager/GoogleTagManager";
import App from "../../App";

interface IRootProps {
  store: Store<IApplicationState>;
}

class Root extends React.Component<IRootProps> {
  public render() {
    return (
      <Provider store={this.props.store}>
        <ErrorBoundary>
          <GoogleTagManager {...config.gtm} />
          <Router>
            <AuthProvider>
              <Authenticator>
                <AnalyticsProvider>
                  <ErrorTrackingProvider appName="user-account-app">
                    <App />
                  </ErrorTrackingProvider>
                </AnalyticsProvider>
              </Authenticator>
            </AuthProvider>
          </Router>
        </ErrorBoundary>
      </Provider>
    );
  }
}

export default Root;
